// Lightweight GA4 event helper. Fires a gtag event when the global tag is present.
// No-op if gtag is unavailable (e.g. analytics blocked) so UX is never affected.
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
